import { render, staticRenderFns } from "./Annotator.vue?vue&type=template&id=2a1f5279&scoped=true&"
import script from "./Annotator.vue?vue&type=script&lang=js&"
export * from "./Annotator.vue?vue&type=script&lang=js&"
import style0 from "./Annotator.vue?vue&type=style&index=0&id=2a1f5279&prod&lang=scss&scoped=true&"
import style1 from "./Annotator.vue?vue&type=style&index=1&id=2a1f5279&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1f5279",
  null
  
)

export default component.exports